"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _react = _interopRequireDefault(require("react"));

var _Header = _interopRequireDefault(require("./Header"));

var _Filter = _interopRequireDefault(require("./Filter"));

var _Table = _interopRequireDefault(require("./Table"));

var _Paging = _interopRequireDefault(require("./Paging"));

var _ListCount = _interopRequireDefault(require("./ListCount"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Page() {
  try {
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "page"
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: "page__content",
      "data-locator": "invoices.content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['filter']
    }, /*#__PURE__*/_react["default"].createElement(_Filter["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement(_Table["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['count']
    }, /*#__PURE__*/_react["default"].createElement(_ListCount["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['paging']
    }, /*#__PURE__*/_react["default"].createElement(_Paging["default"], null))))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "page"
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: "page__content",
      "data-locator": "invoices.content"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    }))));
  }
}

var _default = Page;
exports["default"] = _default;